const { registerBlockType } = wp.blocks;
const { RichText, URLInputButton, InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl, SelectControl } = wp.components;
const { __ } = wp.i18n;

const ButtonEdit = ({ attributes, setAttributes }) => {
  const { link, label, buttonClass, isSolid, buttonStyle } = attributes;

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Button Settings', 'pg')}>
          <ToggleControl
            label={__('Solid')}
            checked={isSolid}
            onChange={(newValue) => {
              setAttributes({
                isSolid: newValue,
                buttonClass: newValue
                  ? `btn ${buttonStyle} btn-solid`
                  : `btn ${buttonStyle} btn-outline`,
              });
            }}
          />
          <SelectControl
            label={__('Button Style', 'pg')}
            value={buttonStyle}
            options={[
              { label: 'Dark', value: 'btn-dark' },
              { label: 'Light', value: 'btn-light' },
            ]}
            onChange={(newStyle) => {
              setAttributes({
                buttonStyle: newStyle,
                buttonClass: isSolid
                  ? `btn ${newStyle} btn-solid`
                  : `btn ${newStyle} btn-outline`,
              });
            }}
          />
        </PanelBody>
      </InspectorControls>

      <a href="#" className={`btn ${buttonClass}`}>
        <RichText
          tagName="span"
          value={label}
          onChange={(newLabel) => setAttributes({ label: newLabel })}
          placeholder={__('Button Label', 'pg')}
        />
        <URLInputButton
          url={link}
          onChange={(newLink) => setAttributes({ link: newLink })}
        />
      </a>
    </>
  );
};

registerBlockType('pg/button', {
  title: __('PG Button', 'pg'),
  icon: 'admin-links',
  category: 'layout',
  attributes: {
    link: {
      type: 'string',
      source: 'attribute',
      attribute: 'href',
      selector: 'a',
    },
    label: {
      type: 'string',
      source: 'html',
      selector: 'span',
    },
    buttonClass: {
      type: 'string',
      default: 'btn btn-dark btn-outline',
    },
    isSolid: {
      type: 'boolean',
      default: false,
    },
    buttonStyle: {
      type: 'string',
      default: 'btn-dark',
    },
  },
  edit: ButtonEdit,
  save: ({ attributes }) => {
    const { link, label, buttonClass } = attributes;
    return (
      <a href={link} className={buttonClass}>
        <RichText.Content tagName="span" value={label} />
      </a>
    );
  },
});
